import { LEAD_DROP_POPUP_1_CONSTANTS } from "./leadDropPopup_1";

const DYNAMIC_FIELDS_JSON_HELPER = `[{"id":"employment","kind":"select","label":"Total Work Experience","placeholder":"Please select employment","required":true,"bind":"c2","options":[{"value":"0-2","label":"0-2 years"},{"value":"3-7","label":"3-7 years"}]},{"id":"fname","kind":"text","label":"First name","required":true,"bind":"first_name"},{"id":"lname","kind":"text","label":"Last name","required":true,"bind":"last_name"},{"id":"hq","kind":"qualification","label":"Highest qualification","placeholder":"Highest qualification","required":true,"bind":"qualification"},{"id":"prog","kind":"course","label":"Program","placeholder":"Select program","required":true,"bind":"course"}]`;

/**
 * Popup 7 reads last-screen imagery/copy from stored row data too; those keys stay in
 * DEFAULT_ROW.from popup 1 but are hidden here so admins only tune the IIT phone flow +
 * OTP + hero + timers. Omitting brochure/existing/new user fields does not strip them from
 * DB—Form4 keeps all keys loaded from API.
 */
const LAST_SCREEN_FIELDS_HIDDEN_IN_ADMIN = new Set([
  "existing_user_desktop_image",
  "existing_user_mobile_image",
  "existing_user_image_alt",
  "existing_user_title",
  "existing_user_description",
  "existing_user_title_color",
  "existing_user_description_color",
  "new_user_desktop_image",
  "new_user_mobile_image",
  "new_user_image_alt",
  "new_user_title",
  "new_user_description",
  "new_user_title_color",
  "new_user_description_color",
  "brochure_desktop_image",
  "brochure_mobile_image",
  "brochure_image_alt",
  "brochure_title",
  "brochure_description",
  "brochure_title_color",
  "brochure_description_color",
  "brochure_link_color",
]);

const POPUP7_SHARED_FIELDS_FROM_1 =
  LEAD_DROP_POPUP_1_CONSTANTS.LEAD_DROP_POPUP_FIELDS_CONFIG.filter(
    (f) =>
      typeof f.fieldName === "string" &&
      !LAST_SCREEN_FIELDS_HIDDEN_IN_ADMIN.has(f.fieldName),
  );

/** Lead Popup 7 — IIT-style phone-first flow + JSON secondary fields (`additional_fields`). */
export const LEAD_DROP_POPUP_7_CONSTANTS = {
  DEFAULT_ROW: {
    ...LEAD_DROP_POPUP_1_CONSTANTS.DEFAULT_ROW,
    form_title: "Please Enter Your Phone No.",
    form_title_color: "#DE5803",
    form_sub_text: "",
    button_color: "#DE5803",
    checkbox_color: "#DE5803",
    edit_text_color: "#DE5803",
    resend_text_color: "#DE5803",
    brochure_link_color: "#DE5803",
    signup_button_text: "Continue",
    get_otp_button_text: "Get OTP",
    verify_otp_button_text: "Verify OTP",
    get_otp_enabled_color: "#DE5803",
    get_otp_disabled_color: "#D4D4D8",
    phone_row_background_color: "#F0F0F7",
    dynamic_field_definitions: "[]",
  },

  LEAD_DROP_POPUP_FIELDS_CONFIG: [
    {
      fieldName: "dynamic_field_definitions",
      label:
        "Extra fields after duplicate check — JSON array (kinds: text | email | select | qualification | course; bind: first_name | last_name → merged name; name | email | qualification | course | interest | c2–c5)",
      value: "[]",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: `Example: ${DYNAMIC_FIELDS_JSON_HELPER}`,
      required: false,
      defaultValue: "[]",
      rows: 8,
      isJsonField: true,
    },
    {
      fieldName: "get_otp_button_text",
      label: "Phone-step button label",
      value: "Get OTP",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Get OTP",
      required: false,
      defaultValue: "Get OTP",
      isJsonField: true,
    },
    {
      fieldName: "verify_otp_button_text",
      label: "OTP-step button label",
      value: "Verify OTP",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Verify OTP",
      required: false,
      defaultValue: "Verify OTP",
      isJsonField: true,
    },
    {
      fieldName: "get_otp_enabled_color",
      label: '"Get OTP" enabled color',
      value: "#DE5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DE5803",
      required: false,
      defaultValue: "#DE5803",
      isJsonField: true,
    },
    {
      fieldName: "get_otp_disabled_color",
      label: '"Get OTP" disabled color',
      value: "#D4D4D8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#D4D4D8",
      required: false,
      defaultValue: "#D4D4D8",
      isJsonField: true,
    },
    {
      fieldName: "phone_row_background_color",
      label: "Phone row background",
      value: "#F0F0F7",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#F0F0F7",
      required: false,
      defaultValue: "#F0F0F7",
      isJsonField: true,
    },
    ...POPUP7_SHARED_FIELDS_FROM_1,
  ],

  METADATA_FIELDS: LEAD_DROP_POPUP_1_CONSTANTS.METADATA_FIELDS,
};
